// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavigationItem-module--wrapper--aAJZm","link":"NavigationItem-module--link--RBgRu"};